import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../i18n/translations";
import { SERVICES } from "../data/mock";

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang].footer;
  const nav = translations[lang].nav;

  return (
    <footer className="bg-navy-950 text-slate-300 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Brand */}
          <div className="lg:pr-8">
            <img
              src="/assets/adalcrea-logo-white.png"
              alt="AdalCrea"
              className="h-11 w-auto object-contain mb-5"
            />
            <p className="text-sm leading-relaxed text-slate-400">{t.about}</p>
            <div className="mt-6 space-y-3 text-sm">
              <a
                href="tel:05438047005"
                className="flex items-center gap-3 hover:text-amber-400 transition-colors"
              >
                <Phone className="w-4 h-4 text-amber-500 shrink-0" />
                0543 804 70 05
              </a>
              <a
                href="mailto:info@adalcrea.com.tr"
                className="flex items-center gap-3 hover:text-amber-400 transition-colors"
              >
                <Mail className="w-4 h-4 text-amber-500 shrink-0" />
                info@adalcrea.com.tr
              </a>
              <p className="flex items-start gap-3 text-slate-400">
                <MapPin className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />
                Zuhuratbaba Mah. Tatlınar Sokak No 2, Bakırköy / İstanbul
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-display font-semibold text-sm tracking-wider mb-5">
              {t.servicesTitle}
            </h4>
            <ul className="space-y-3 text-sm">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/hizmetlerimiz/${s.slug}`}
                    className="text-slate-400 hover:text-amber-400 transition-colors"
                  >
                    {s.title[lang]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-display font-semibold text-sm tracking-wider mb-5">
              {t.companyTitle}
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/hakkimizda" className="text-slate-400 hover:text-amber-400 transition-colors">
                  {nav.about}
                </Link>
              </li>
              <li>
                <Link to="/hizmetlerimiz" className="text-slate-400 hover:text-amber-400 transition-colors">
                  {nav.services}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-slate-400 hover:text-amber-400 transition-colors">
                  {nav.blog}
                </Link>
              </li>
              <li>
                <Link to="/referanslar" className="text-slate-400 hover:text-amber-400 transition-colors">
                  {nav.references}
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-slate-400 hover:text-amber-400 transition-colors">
                  {nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-white font-display font-semibold text-sm tracking-wider mb-5">
              {t.newsletter}
            </h4>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex items-center bg-white/5 border border-white/10 rounded-lg overflow-hidden focus-within:border-amber-500 transition-colors"
            >
              <input
                type="email"
                required
                placeholder={t.emailPlaceholder}
                className="flex-1 bg-transparent px-4 py-3 text-sm text-white placeholder:text-slate-500 outline-none"
              />
              <button
                type="submit"
                className="bg-amber-500 hover:bg-amber-400 text-navy-950 p-3 transition-colors"
                aria-label={t.subscribe}
              >
                <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            <div className="mt-6">
              <h4 className="text-white font-display font-semibold text-sm tracking-wider mb-4">
                {t.legalTitle}
              </h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/gizlilik" className="text-slate-400 hover:text-amber-400 transition-colors">
                    {t.privacy}
                  </Link>
                </li>
                <li>
                  <Link to="/kullanim-kosullari" className="text-slate-400 hover:text-amber-400 transition-colors">
                    {t.terms}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© 2026 AdalCrea Dijital Dönüşüm Ajansı. {t.rights}</p>
          <p>{t.location}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
